import React, { Fragment } from 'react';
import './SelectState.scss';
import areaNames from '../../areaNames';

function SelectState({ currentData, handleClickSelectState, handleClickArea, selectState }) {
  return (
    <section className="selectState mobile-only" ref={selectState}>
      <div className="selectState__content">
        {currentData ? (
          <>
            {Object.keys(areaNames).map((area, i) => {
              return (
                <Fragment key={i}>
                  <p
                    className={`selectState__content__area selectState-${i}-mobile`}
                    onClick={() => {
                      handleClickSelectState('close');
                      handleClickArea(area);
                    }}
                  >
                    {area}
                  </p>
                </Fragment>
              );
            })}
          </>
        ) : (
          <></>
        )}
      </div>
    </section>
  );
}

export default SelectState;
